
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-pubsub",
      function () {
        return require("private-next-pages/destinations/google-pubsub.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-pubsub"])
      });
    }
  